'use client';

import { signIn } from 'next-auth/react'; // Adjust the import based on your NextAuth.js setup

import { setSessionData } from 'actions/common/sessionHandler'; // Adjust the import based on your project structure

export type PublicOAuthProvider = {
  name: string;
  clientId: string;
};

export async function oAuthLogin(
  provider: PublicOAuthProvider,
  callbackUrl: string,
  redirectUrlAfterFailure?: string,
): Promise<void> {
  if (redirectUrlAfterFailure) {
    const oauthLoginParamsSessionData = {
      redirectUrlAfterFailure,
      expiry: Date.now() + 15 * 60 * 1000, // 15 minutes expiry
    };

    // Set session data in cookies
    await setSessionData('oauthLoginParams', oauthLoginParamsSessionData);
  }

  await signIn(provider.name, {
    clientId: provider.clientId,
    callbackUrl,
  });
}
